import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { rootStore } from '../../mobx/rootStore';
import BottomNavigation from '.';

const BottomNavigationWrapper = () => {
  const location = useLocation();
  // mobx store variable
  const { appStore } = rootStore || {};
  const { isAppLoading } = appStore || {};

  if (isAppLoading) return null;

  if (
    location.pathname === '/' ||
    location.pathname === '/home' ||
    location.pathname === '/setting' ||
    location.pathname === '/search'
  ) {
    return <BottomNavigation />;
  }

  return null;
};

export default observer(BottomNavigationWrapper);
